import { Card, Flex, Skeleton } from 'antd';

import { SPACE_SM } from '@/theme/buildAntdTheme';

type FilteredListingCardSkeletonProps = {
  rows?: number;
};

/** Card-grid first-paint placeholder for recruiter-management style listings. */
export function FilteredListingCardSkeleton({
  rows = 4,
}: FilteredListingCardSkeletonProps) {
  return (
    <Flex vertical gap={SPACE_SM} data-testid="filtered-listing-skeleton">
      {Array.from({ length: rows }, (_, index) => (
        <Card
          key={`filtered-listing-skeleton-${index}`}
          variant="outlined"
          size="small"
        >
          <Flex align="center" gap="small">
            <Flex vertical flex={1}>
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 2, width: ['64%', '38%'] }}
              />
            </Flex>
            <Skeleton.Button active size="small" />
          </Flex>
        </Card>
      ))}
    </Flex>
  );
}
